import { WidgetType } from "@codemirror/view";
import katex from "katex";
import { attachSyntaxEditInteractions } from "../shared/widgets";

export class PrettyMarkdownMathWidget extends WidgetType {
    constructor(
        readonly formula: string,
        readonly displayMode: boolean,
        readonly editPosition: number,
    ) {
        super();
    }

    eq(other: PrettyMarkdownMathWidget): boolean {
        return other.formula === this.formula &&
            other.displayMode === this.displayMode &&
            other.editPosition === this.editPosition;
    }

    toDOM(): HTMLElement {
        const wrapper = document.createElement("span");
        wrapper.className = [
            "cm-magic-markdown-math",
            this.displayMode
                ? "cm-magic-markdown-math-block"
                : "cm-magic-markdown-math-inline",
        ].join(" ");
        wrapper.title = this.formula;

        try {
            wrapper.innerHTML = katex.renderToString(this.formula, {
                displayMode: this.displayMode,
                throwOnError: false,
                strict: "ignore",
                output: "htmlAndMathml",
            });
        } catch {
            wrapper.textContent = this.formula;
            wrapper.classList.add("cm-magic-markdown-math-error");
        }

        attachSyntaxEditInteractions(wrapper, {
            keyboard: false,
            position: this.editPosition,
        });

        return wrapper;
    }

    ignoreEvent(): boolean {
        return true;
    }
}
